exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n.imageCard{\r\n    border-radius: 100%;\r\n    max-width: 50px;\r\n    float: left\r\n}\r\n\r\n\r\n.image-action img {\r\n    width:100%; \r\n    margin-bottom: 10px;\r\n    -webkit-transition: all .2s ease-in-out;\r\n    transition: all .2s ease-in-out;\r\n}\r\n\r\n\r\n.image-action img:hover {\r\n    width: 100.5%;\r\n    -webkit-filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.9));\r\n            filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.9))\r\n}\r\n\r\n\r\n.soc-ic{\r\n    padding: 5px;\r\n    font-size: 20px;\r\n    color: #515365;\r\n}\r\n\r\n\r\n.superScroll2 {\r\n    position: fixed !important;\r\n    top:125px !important;\r\n    -webkit-transition: margin-top .25s ease-in-out !important;\r\n    transition: margin-top .25s ease-in-out !important;\r\n    width: 245px;\r\n}\r\n\r\n\r\n/* a:hover{\r\n    color: gray;\r\n} */", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/follow-widget/follow-widget.component.css
// module id = ../../../../../src/app/follow-widget/follow-widget.component.css
// module chunks = main